import reducer from "./reducers";

export {
  fetchBackupSettingsStart,
  saveBackupSettingsStart,
  updateBackupSettingsStart,
  initiateFullBackup,
  removeMachineStart,
  addClientsToPlanStart
} from "./operations";
export default reducer;
